import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api, type Strategy } from "@/lib/api";

export function useStrategy(projectId: string | null | undefined) {
  return useQuery({
    queryKey: ["strategy", projectId],
    queryFn: () => api.getStrategy(projectId!),
    enabled: Boolean(projectId),
  });
}

export function useUpdateStrategy(projectId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: Partial<Strategy>) => api.updateStrategy(projectId, body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["strategy", projectId] });
    },
  });
}
